import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableAudiences = Loadable({
  loader: function loader() {
    return import('../Audiences/Audiences.jsx');
  },
  loading: ComponentLoading
});
export default LoadableAudiences;